var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container-fluid',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"12"}},[_c('div',[_c('tools-transcribe')],1)])],1),(_vm.canViewAllUsers)?_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"12"}},[_c('div',[_c('all-users')],1)])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }